import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptEvolucionSueldos (personalRpt) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Evolucion de Sueldos",
        Subject: "EvolucionSueldos",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [ [] ];

      let header = [
        'Personal'
      ]

      if (personalRpt) {
        if (personalRpt[0].periodos) {
          personalRpt[0].periodos.forEach(periodoLiquidacion => {
            header.push(this.$options.filters.periodo(periodoLiquidacion.periodo))
          });
        }
      }
      data.push(header);

      if (personalRpt) {
        personalRpt.forEach(personal => {
          let dataPersonal = [ personal.nombre ];

          if (personal.periodos) {
            personal.periodos.forEach(periodoLiquidacion => {

              dataPersonal.push(periodoLiquidacion.total);
            });
          }

          data.push(dataPersonal);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "EvolucionSueldos");
      XLSX.writeFile(wb, "evolucion-sueldos.xlsx");

      return;
    }
  }
}
